export default __webpack_public_path__ + "0991f80ed7d9b5b7ec98065d7e9f6e07.svg";